import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

interface IKPITarget {
  target: number;
}

const KPITarget: FC<IKPITarget> = ({ target }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const r = 115;
  const curveLength = Math.PI * r;
  const angle = ((target / 100) * curveLength * 180) / (Math.PI * r) - 90;

  const angleByValue = ((target <= 50 ? 90 + angle : 90 - angle) * Math.PI) / 180;

  const x = Math.cos(angleByValue) * r;
  const y = Math.sin(angleByValue) * r;

  return (
    <g style={{ transform: 'translate(50%, 12px)' }}>
      <path
        d="M1.43536 21.8701L1.43536 1.87012"
        stroke={theme.colors.neutral.primary[80]}
        strokeLinecap="round"
        strokeWidth="2"
        style={{
          transform: `rotateZ(${angle}deg)`,
          transformOrigin: '0 136px 0',
        }}
      />
      <text
        x={0}
        dx={target > 50 ? x + 16 : -x - 120}
        y={0}
        dy={120 - y}
        fill={theme.colors.neutral.primary[80]}
        fontSize={14}
        fontWeight={700}
      >
        {t('report.kpi.target', { target })}
      </text>
    </g>
  );
};

export default KPITarget;
